var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1568 1.19102C15.4115 1.44571 15.4115 1.85864 15.1568 2.11333L6.46116 10.809C6.20647 11.0637 5.79353 11.0637 5.53884 10.809L1.19102 6.46116C0.936328 6.20647 0.936328 5.79353 1.19102 5.53884C1.44571 5.28415 1.85864 5.28415 2.11333 5.53884L6 9.42551L14.2345 1.19102C14.4892 0.936328 14.9021 0.936328 15.1568 1.19102Z",
    fill: "#051123",
    stroke: "#051123",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTick);
export default __webpack_public_path__ + "static/media/black_tick.fd875ba7ca52349466a09df7e64b4d57.svg";
export { ForwardRef as ReactComponent };